<template>
  <div>
    <div v-if="!loading">
      <app-form
        v-bind:parentObject="{
          data: this.formData,
          searchnew: this.search,
          pageTitle: this.pageTitle,
          pageTitleValue: this.pageTitleValue,
          errMsg: this.errMsg,
          isEdit: this.editMode,
        }"
        v-on:input="formData = $event"
        v-on:new="createHandler"
        v-on:save="saveHandler"
        v-on:delete="isConfirm = !isConfirm"
        v-on:error="errorHandler"
      />

      <div v-if="isErr">
        <app-error
          v-bind:parentError="{
            data: this.errMsg,
            isErr: this.isErr,
          }"
          v-on:closeError="isErr = $event"
        />
      </div>

      <div v-if="isConfirm">
        <app-confirm
          v-bind:parentObject="{
            pageTitleValue: this.pageTitleValue,
            isConfirm: this.isConfirm,
          }"
          v-on:confirm="deleteHandler($event)"
          v-on:cancelConfirm="isConfirm = !isConfirm"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

import PositionForm  from '../../../components/settings/position/Form';
import ErrorDialog   from '../../../components/common/ErrorDialog';
import ConfirmDialog from '../../../components/common/ConfirmDialog';

export default {
  components: {
    'app-form':    PositionForm,
    'app-error':   ErrorDialog,
    'app-confirm': ConfirmDialog,
  },

  data() {
    return {
      id:         this.$route.params.id,
      detailid:   this.$route.query.detailid || null,
      search:     this.$route.params.search,
      parentStamp: 0,
      pageTitle:      this.$t('setupposition.editposition'),
      pageTitleValue: '',
      formData: {
        id:         null,
        positionid: null,
        poscode:    null,
        posdesc:    null,
        isdisable:  false,
        remark:     null,
        startdate:  null,
        enddate:    null,
        positioncount:      null,
        repposid:   null,
        compnyid:   null,
        brchid:     null,
        divnid:     null,
        deptid:     null,
        sectioid:   null,
        unitid:     null,
        jobid:      null,
        grdid:      null,
        emptypeid:  null,
        stamp:      0,
        userid:     this.$store.getters.userId,
      },
      errMsg:   '',
      isErr:    false,
      loading:  true,
      editMode: true,
      isConfirm: false,
    };
  },

  methods: {
    errorHandler($event) {
      this.isErr  = $event.isErr;
      this.errMsg = $event.errMsg;
    },

    saveHandler() {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, 'canedit')) {
        return false;
      }

      const detailPayload = {
        positionid: this.formData.positionid,
        startdate:  this.formData.startdate,
        enddate:    this.formData.enddate,
        count:      this.formData.positioncount,
        repposid:   this.formData.repposid,
        compnyid:   this.formData.compnyid,
        brchid:     this.formData.brchid,
        divnid:     this.formData.divnid,
        deptid:     this.formData.deptid,
        sectioid:   this.formData.sectioid,
        unitid:     this.formData.unitid,
        jobid:      this.formData.jobid,
        grdid:      this.formData.grdid,
        emptypeid:  this.formData.emptypeid,
        stamp:      this.formData.stamp,
        userid:     this.formData.userid,
      };

      const parentPayload = {
        poscode:   this.formData.poscode,
        posdesc:   this.formData.posdesc,
        isdisable: this.formData.isdisable ? 1 : 0,
        remark:    this.formData.remark,
        stamp:     this.parentStamp,
        userid:    this.formData.userid,
      };

      // Save detail first (carries count validation); only save parent if detail succeeds.
      // Running both concurrently caused the parent stamp to increment even when the
      // detail was rejected, making every subsequent save fail with "Record Has Been Changed".
      this.$store.dispatch('put', { url: '/position/detail/' + vm.detailid, payload: detailPayload })
        .then(detailRes => {
          if (detailRes.data && detailRes.data.error) {
            vm.isErr  = true;
            vm.errMsg = detailRes.data.error;
            return null;
          }
          return this.$store.dispatch('put', { url: '/position/' + vm.id, payload: parentPayload });
        })
        .then(parentRes => {
          if (!parentRes) return;
          if (parentRes.data && parentRes.data.error) {
            vm.isErr  = true;
            vm.errMsg = parentRes.data.error;
          } else {
            this.$router.push({ name: 'positionlist', params: { search: this.search } });
          }
        })
        .catch(err => {
          vm.isErr  = true;
          vm.errMsg = err;
        });
    },

    deleteHandler($event) {
      const vm = this;

      if (!this.CheckPermission(this.$route.meta.funcname, 'candelete')) {
        return false;
      }

      this.isConfirm = !this.isConfirm;

      if ($event) {
        // Delete the parent position (cascades all child details).
        this.$store.dispatch('delete', {
          url: '/position/' + this.id + '/' + this.formData.userid,
        })
          .then(res => {
            if (res.data.error) {
              vm.isErr  = true;
              vm.errMsg = res.data.error;
            } else {
              this.$router.push({ name: 'positionlist' });
            }
          })
          .catch(err => {
            vm.isErr  = true;
            vm.errMsg = err;
          });
      }
    },

    createHandler() {
      this.$router.push({ name: 'positionnew' });
    },

    loadPositionHandler() {
      const vm = this;

      Promise.all([
        this.$store.dispatch('get', { url: '/position/detail/' + vm.detailid }),
        this.$store.dispatch('get', { url: '/position/' + vm.id }),
      ])
        .then(([detailRes, parentRes]) => {
          if (detailRes.status !== 200) { vm.isErr = true; return; }

          const rec = detailRes.data.rec;
          const row = Array.isArray(rec) ? rec[0] : rec;
          if (!row) { vm.loading = false; return; }

          const parentRec = parentRes.data.rec;
          const parentRow = Array.isArray(parentRec) ? parentRec[0] : parentRec;
          vm.parentStamp = parentRow ? (parentRow.stamp || 0) : 0;

          vm.formData = {
            id:         row.id,
            positionid: row.positionid,
            poscode:    row.poscode,
            posdesc:    row.posdesc,
            isdisable:  row.isdisable === 'N' ? false
                      : row.isdisable === 'Y' ? true
                      : Boolean(row.isdisable),
            remark:    row.remark,
            startdate: row.startdate ? moment(row.startdate).format('YYYY-MM-DD') : null,
            enddate:   row.enddate   ? moment(row.enddate).format('YYYY-MM-DD')   : null,
            positioncount:     row.positioncount     || null,
            repposid:  row.repposid  || null,
            compnyid:  row.compnyid  || null,
            brchid:    row.brchid    || null,
            divnid:    row.divnid    || null,
            deptid:    row.deptid    || null,
            sectioid:  row.sectioid  || null,
            unitid:    row.unitid    || null,
            jobid:     row.jobid     || null,
            grdid:     row.grdid     || null,
            emptypeid: row.emptypeid || null,
            stamp:     row.stamp     || 0,
            userid:    vm.$store.getters.userId,
          };

          vm.pageTitleValue = vm.formData.posdesc;
          vm.loading = false;
        })
        .catch(err => {
          vm.isErr  = true;
          vm.errMsg = err;
          vm.loading = false;
        });
    },
  },

  mounted() {
    this.loadPositionHandler();
  },
};
</script>
